import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import InvestComponent from './Invest.component';

interface StateProps {
  activeProfileId?: number;
  loggedUserData?: number;
}

interface DispatchProps {
}

interface OwnProps {
  listKey: string;
}

interface Props extends StateProps, DispatchProps, OwnProps {
}

class InvestContainer extends React.Component<Props> {

  static defaultProps = {
    listKey: 'openProjects'
  };

  constructor(props: Props) {
    super(props);
  }

  public render(): React.ReactNode {
    return (
      <InvestComponent
        listKey={this.props.listKey}
      />
    );
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {};
};

const mapStateToProps: (state: RootState, ownProps: OwnProps) => StateProps = (state: RootState, ownProps: OwnProps):
  StateProps => ({
  activeProfileId: state.getUser.activeProfile ? state.getUser.activeProfile.id : undefined,
  loggedUserData: state.authentication.loggedUserData || undefined,
});

const MyProjectsListContainer = connect(mapStateToProps, mapDispatchToProps)(InvestContainer);

MyProjectsListContainer.defaultProps = InvestContainer.defaultProps;

export default MyProjectsListContainer;


// WEBPACK FOOTER //
// ./src/modules/invest/Invest.container.tsx